import { takeEvery } from 'redux-saga/effects';
import { fetchHoveredParcelByCoords } from './fetch-hovered-parcel';
import { setInitialViewport } from './set-initial-viewport';
import { fetchFilterBbox } from './fetch-filter-bbox';

export function* fetchHoveredParcelSaga() {
  yield takeEvery('GET_HOVERED_PARCEL', fetchHoveredParcelByCoords);
}
export function* setInitialViewportSaga() {
  yield takeEvery('SET_INITIAL_VIEWPORT', setInitialViewport);
}
export function* fetchFilterBboxSaga() {
  yield takeEvery('GET_FILTER_BBOX', fetchFilterBbox);
}
